const dustjs = require('dustjs');
const Backbone = require('backbone');
const _facetGroupItemDust = require('store/global/pages/categories/_facet_group_item.dust');
const _facetGroupItemDustLDI = require('store/themes/livingdirect/global/pages/categories/_facet_group_item.dust');
const _mobileFacetGroupItemDustLDI = require('store/themes/livingdirect/global/pages/categories/_mobile_facet_group_item.dust');

module.exports = Backbone.View.extend({
	tagName: 'li',
	className: function() {
		const desktopLDI = window.BCOM.device.isDesktop ? '' : 'pl3 pv2';
		const desktopBuild = window.BCOM.device.isDesktop ? 'mv0-l pl0-l' : '';
		return window.BCOM.theme.isLivingDirect ? `ma0 bg-theme-white ${desktopLDI}` : `mh0 mv1 mv2-m pl2 ${desktopBuild}`;
	},
	events: {
		click: '_changeFacet'
	},
	initialize: function() {
		this._setTemplate();
		this.listenTo(this.model, 'change:selected', this.render);
		this.listenTo(this.model, 'destroy', this._onDestroy);
	},
	_setTemplate() {
		const _deviceTemplateLDI = window.BCOM.device.isDesktop ? _facetGroupItemDustLDI : _mobileFacetGroupItemDustLDI;
		this._template = window.BCOM.theme.isLivingDirect ? _deviceTemplateLDI : _facetGroupItemDust;
	},
	_onDestroy() {
		this.remove();
	},
	_changeFacet: function(e) {
		e.preventDefault();
		const $inputLabel = $(e.target).closest('label');
		const gbiFacetType = this._getGBIFacetType(this.model);
		const facetType = this.model.get('attributeName') || gbiFacetType;
		const facetValue = $inputLabel.data('facet-value');

		// only track if the user is selecting a facet that is currently unselected
		if (!this.model.get('selected') && facetType) {
			window.BCOM.util.trackFilterItems(facetType, facetValue);
		}

		if (window.BCOM.theme.isLivingDirect && window.BCOM.device.isDesktop) {
			window.location.assign($(e.target).data('facet-url'));
		} else {
			this.model.set('selected', !this.model.get('selected'));
		}
	},
	_getGBIFacetType: function(model) {
		const facetId = model.get('facetId');
		if (typeof facetId === 'string') {
			const idArr = facetId.split('.');
			return idArr[idArr.length - 1];
		}
	},
	render: function() {
		const { device } = window.BCOM || { device: undefined },
			data = Object.assign({ device }, this.model.toJSON());
		dustjs.render(this._template, data, this._handleDustResults.bind(this));
		return this;
	},
	_handleDustResults: function(error, markup) {
		if (!error) {
			this.$el.html(markup);
		}
	}
});
